import moment from "moment";
import { useState } from "react";
import { useCookies } from "react-cookie";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { FiLock, FiUser } from "react-icons/fi";
import Alert from "../components/Alert";
import Button from "../components/Button";
import Loader from "../components/Loader";
import TextInput from "../components/TextInput";
import service from "../service";

export default function Login() {
  const { register, handleSubmit } = useForm();
  const setCookies = useCookies()[1];
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [fail, setFail] = useState(false);

  const _login = ({ username, password }) => {
    setLoading(true);
    service
      .post("/api/auth/admin/get-token", {
        username,
        password,
      })
      .then((response) => {
        setFail(false);
        setLoading(false);
        const { id, username, role } = response.data;
        // Auth: httpOnly admin_token + admin_logged_in flag from API
        const exp = moment().add(7, "days").toDate();
        setCookies("id", id, { path: "/", expires: exp });
        setCookies("username", username, { path: "/", expires: exp });
        setCookies("admin_logged_in", "1", { path: "/", expires: exp });
        setCookies("role", role, { path: "/", expires: exp });
        history.push("/");
      })
      .catch((e) => {
        setFail(
          e?.response?.data?.message ||
            e?.message ||
            "Autentikasi gagal"
        );
        setLoading(false);
      });
  };

  return (
    <div className="bg-background min-h-screen flex justify-center items-center">
      <Helmet>
        <title>Login</title>
      </Helmet>
      <div className="w-full lg:w-1/3 xl:w-1/4 rounded-lg bg-white-100 m-8 p-8 shadow-soft border border-white-200">
        <h1 className="montserrat-alternates text-primary-600 font-bold text-2xl">
          Admin Panel
        </h1>
        <h2 className="text-black-300 mt-1">Silahkan masuk ke akun Anda</h2>
        <form className="mt-6" onSubmit={handleSubmit(_login)}>
          {fail ? (
            <Alert className="mb-4 text-center">
              {typeof fail === "string" ? fail : "Autentikasi gagal"}
            </Alert>
          ) : null}
          <TextInput
            {...register("username", { required: true })}
            left={<FiUser size={16} />}
            placeholder="Username"
            type="text"
            containerClassName="mb-3"
          />
          <TextInput
            {...register("password", { required: true })}
            left={<FiLock size={16} />}
            placeholder="Password"
            type="password"
            containerClassName="mb-4"
          />
          <Button type="submit" className="w-full">
            {loading ? <Loader className="bg-white-100" /> : "Masuk"}
          </Button>
        </form>
      </div>
    </div>
  );
}
